import { orchestrator } from "satcheljs";
import { onAddinSubcommandsTrigger } from "owa-nova-actions";

orchestrator(onAddinSubcommandsTrigger, actionMessage => {
    const { event } = actionMessage;
    const data = event.data?.();
    data?.reactEvent?.preventDefault();
});
